import React from 'react'
import { useLanguage } from '../context/LanguageContext';

const WebsiteSchemes = () => {
  const { language } = useLanguage();

  const caseStudyData = [
    { stage: { marathi: 'योजना निर्मिती', english: 'Scheme Formulation' }, work: { marathi: 'ग्रामसभा चर्चा', english: 'Gram Sabha Discussion' }, officer: { marathi: 'सरपंच', english: 'Sarpanch' }, duration: { marathi: '१५ दिवस', english: '15 Days' } },
    { stage: { marathi: 'मंजुरी', english: 'Approval' }, work: { marathi: 'तकनीकी तपासणी', english: 'Technical Inspection' }, officer: { marathi: 'अभियंता', english: 'Engineer' }, duration: { marathi: '१० दिवस', english: '10 Days' } },
    { stage: { marathi: 'अंमलबजावणी', english: 'Implementation' }, work: { marathi: 'खोदकाम व बांधकाम', english: 'Excavation & Construction' }, officer: { marathi: 'बांधकाम अधिकारी', english: 'Construction Officer' }, duration: { marathi: '३ महिने', english: '3 Months' } },
    { stage: { marathi: 'मूल्यमापन', english: 'Evaluation' }, work: { marathi: 'कार्य पूर्णता तपासणी', english: 'Work Completion Check' }, officer: { marathi: 'ग्रामसेवक', english: 'Gram Sevak' }, duration: { marathi: '७ दिवस', english: '7 Days' } },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8">
      {/* Main Title Section */}
      <div className="text-center mb-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          {language === 'marathi' ? 'योजना व कार्यपद्धती' : 'Schemes & Procedures'}
        </h1>
        <div className="flex justify-center items-center mb-6">
          <div className="w-24 h-1 bg-green-500"></div>
          <div className="mx-4 text-green-600">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="w-24 h-1 bg-green-500"></div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto space-y-8">
        {/* SECTION 1 */}
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gray-100">
          <div className="flex items-start mb-6">
            <div className="bg-green-100 p-3 rounded-full mr-4">
              <span className="text-2xl">🌱</span>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                {language === 'marathi' ? '१. योजना (Planning)' : '1. Planning'}
              </h2>
              <p className="text-gray-600 mb-6">
                {language === 'marathi' 
                  ? 'ग्रामस्तरावर विकास योजनांची नियोजनबद्ध अंमलबजावणी करण्यासाठी ठरवलेली प्रक्रिया.'
                  : 'The procedure laid down for the systematic implementation of development schemes at the village level.'}
              </p>
              
              <div className="mb-8">
                <h3 className="text-lg font-semibold text-gray-700 mb-4">{language === 'marathi' ? 'Sub-Menu / Sub-Sections:' : 'Sub-Sections:'}</h3>
                <ul className="space-y-2 pl-5">
                  {[
                    { marathi: 'ग्रामपंचायत नियोजन प्रक्रिया', english: 'Gram Panchayat Planning Process' },
                    { marathi: 'वार्षिक योजना', english: 'Annual Plan' },
                    { marathi: 'पंचवार्षिक योजना', english: 'Five-Year Plan' }
                  ].map((item, index) => (
                    <li key={index} className="flex items-center">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                      <span>{language === 'marathi' ? item.marathi : item.english}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
                  <span className="bg-green-100 p-2 rounded-lg mr-3">🔸</span>
                  {language === 'marathi' ? 'प्रमुख योजना प्रकार' : 'Major Scheme Types'}
                </h3>
                
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {/* Card 1 */}
                  <div className="border border-green-100 rounded-xl p-5 bg-green-50">
                    <div className="flex items-center mb-3">
                      <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3">
                        <span className="text-green-600">✓</span>
                      </div>
                      <h4 className="font-bold text-gray-800">{language === 'marathi' ? 'मूलभूत सुविधा योजना' : 'Basic Amenities Schemes'}</h4>
                    </div>
                    <p className="text-gray-600 text-sm">
                      {language === 'marathi' ? 'रस्ते, गटारी, पिण्याचे पाणी, दिवाबत्ती, समाजमंदिर विकास' : 'Roads, drainage, drinking water, street lights, community hall'}
                    </p>
                  </div>

                  {/* Card 2 */}
                  <div className="border border-blue-100 rounded-xl p-5 bg-blue-50">
                    <div className="flex items-center mb-3">
                      <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                        <span className="text-blue-600">✓</span>
                      </div>
                      <h4 className="font-bold text-gray-800">{language === 'marathi' ? 'सामाजिक विकास योजना' : 'Social Development Schemes'}</h4>
                    </div>
                    <p className="text-gray-600 text-sm">
                      {language === 'marathi' ? 'शिक्षण, आरोग्य, महिला व बालकल्याण, अपंग कल्याण' : 'Education, health, women & child welfare, disability welfare'}
                    </p>
                  </div>

                  {/* Card 3 */}
                  <div className="border border-yellow-100 rounded-xl p-5 bg-yellow-50">
                    <div className="flex items-center mb-3">
                      <div className="w-8 h-8 bg-yellow-100 rounded-lg flex items-center justify-center mr-3">
                        <span className="text-yellow-600">✓</span>
                      </div>
                      <h4 className="font-bold text-gray-800">{language === 'marathi' ? 'आर्थिक विकास योजना' : 'Economic Dev. Schemes'}</h4>
                    </div>
                    <p className="text-gray-600 text-sm">
                      {language === 'marathi' ? 'स्वयंरोजगार, शेती अनुदान, उद्योग प्रशिक्षण, बचत गट' : 'Self-employment, agriculture subsidy, industry training, SHGs'}
                    </p>
                  </div>

                  {/* Card 4 */}
                  <div className="border border-emerald-100 rounded-xl p-5 bg-emerald-50">
                    <div className="flex items-center mb-3">
                      <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center mr-3">
                        <span className="text-emerald-600">✓</span>
                      </div>
                      <h4 className="font-bold text-gray-800">{language === 'marathi' ? 'पर्यावरण व स्वच्छता योजना' : 'Environment & Sanitation Schemes'}</h4>
                    </div>
                    <p className="text-gray-600 text-sm">
                      {language === 'marathi' ? 'स्वच्छ भारत अभियान, वृक्षलागवड, जलसंधारण, प्लास्टिक बंदी' : 'Swachh Bharat, tree plantation, water conservation, plastic ban'}
                    </p>
                  </div>

                  {/* Card 5 */}
                  <div className="border border-purple-100 rounded-xl p-5 bg-purple-50">
                    <div className="flex items-center mb-3">
                      <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center mr-3">
                        <span className="text-purple-600">✓</span>
                      </div>
                      <h4 className="font-bold text-gray-800">{language === 'marathi' ? 'डिजिटल ग्राम योजना' : 'Digital Village Schemes'}</h4>
                    </div>
                    <p className="text-gray-600 text-sm">
                      {language === 'marathi' ? 'ग्रामपंचायत ई-सेवा, ऑनलाइन दाखले, डिजिटल हजेरी' : 'Gram Panchayat e-services, online certificates, digital attendance'}
                    </p>
                  </div>

                  {/* Card 6 */}
                  <div className="border border-red-100 rounded-xl p-5 bg-red-50">
                    <div className="flex items-center mb-3">
                      <div className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center mr-3">
                        <span className="text-red-600">✓</span>
                      </div>
                      <h4 className="font-bold text-gray-800">{language === 'marathi' ? 'आपत्ती व्यवस्थापन योजना' : 'Disaster Management Schemes'}</h4>
                    </div>
                    <p className="text-gray-600 text-sm">
                      {language === 'marathi' ? 'पूर, दुष्काळ, अग्निपासून बचाव योजना' : 'Flood, drought, fire protection schemes'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 2 */}
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gray-100">
          <div className="flex items-start mb-6">
            <div className="bg-blue-100 p-3 rounded-full mr-4">
              <span className="text-2xl">⚙️</span>
            </div>
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                {language === 'marathi' ? '२. कार्यपद्धती (Implementation Procedure)' : '2. Implementation Procedure'}
              </h2>
              <p className="text-gray-600 mb-8">
                {language === 'marathi' 
                  ? 'ग्रामपंचायत योजना अमलात आणताना शासन मार्गदर्शक तत्त्वे व ग्रामसभेचे निर्णय यांचा आधार घेतला जातो.'
                  : 'While implementing Gram Panchayat schemes, government guidelines and Gram Sabha decisions are taken as the basis.'}
              </p>
              
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
                  <span className="bg-blue-100 p-2 rounded-lg mr-3">🔸</span>
                  {language === 'marathi' ? 'टप्पावार कार्यपद्धत' : 'Step-by-step Procedure'}
                </h3>
                
                <div className="space-y-4">
                  {[
                    { marathi: 'ग्रामसभेची बैठक', english: 'Gram Sabha Meeting' },
                    { marathi: 'कार्यक्रम आखणी', english: 'Program Planning' },
                    { marathi: 'निधीची तरतूद', english: 'Fund Provision' },
                    { marathi: 'कामाची अंमलबजावणी', english: 'Implementation of Work' },
                    { marathi: 'देखरेख व मूल्यमापन', english: 'Monitoring & Evaluation' },
                    { marathi: 'अहवाल सादरीकरण व पारदर्शकता', english: 'Report Presentation & Transparency' }
                  ].map((step, index) => (
                    <div key={index} className="flex items-center p-4 bg-gray-50 rounded-lg">
                      <div className="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold mr-4">
                        {index + 1}
                      </div>
                      <span className="text-gray-800 font-medium">{language === 'marathi' ? step.marathi : step.english}</span>
                      <div className="ml-auto text-blue-500">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 3 */}
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gray-100">
          <div className="flex items-start mb-6">
            <div className="bg-purple-100 p-3 rounded-full mr-4">
              <span className="text-2xl">📋</span>
            </div>
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                {language === 'marathi' ? '३. उदाहरणे (Case Study)' : '3. Case Study'}
              </h2>
              
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-gray-700 mb-4">{language === 'marathi' ? 'जलसंधारण योजना' : 'Water Conservation Scheme'}</h3>
                
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200 border border-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
                          {language === 'marathi' ? 'टप्पा' : 'Stage'}
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
                          {language === 'marathi' ? 'कार्य' : 'Work'}
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
                          {language === 'marathi' ? 'जबाबदार अधिकारी' : 'Responsible Officer'}
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          {language === 'marathi' ? 'कालावधी' : 'Duration'}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {caseStudyData.map((row, index) => (
                        <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 border-r">
                            {language === 'marathi' ? row.stage.marathi : row.stage.english}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border-r">
                            {language === 'marathi' ? row.work.marathi : row.work.english}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border-r">
                            {language === 'marathi' ? row.officer.marathi : row.officer.english}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {language === 'marathi' ? row.duration.marathi : row.duration.english}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 4 */}
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gray-100">
          <div className="flex items-start mb-6">
            <div className="bg-orange-100 p-3 rounded-full mr-4">
              <span className="text-2xl">📊</span>
            </div>
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                {language === 'marathi' ? '४. अपेक्षित परिणाम (Expected Outcomes)' : '4. Expected Outcomes'}
              </h2>
              
              <div className="grid md:grid-cols-2 gap-6">
                {[
                  { marathi: 'गावातील सुविधा सुधारतात', english: 'Village facilities improve' },
                  { marathi: 'नागरिकांचा सहभाग वाढतो', english: 'Citizen participation increases' },
                  { marathi: 'रोजगारनिर्मिती होते', english: 'Employment is generated' },
                  { marathi: 'आर्थिक प्रगती होते', english: 'Economic progress occurs' },
                  { marathi: 'प्रशासनातील पारदर्शकता वाढते', english: 'Transparency in administration increases' },
                  { marathi: 'ग्रामपंचायत "आदर्श ग्राम" होण्याच्या दिशेने वाटचाल करते', english: 'Gram Panchayat progresses towards becoming an "Ideal Village"' }
                ].map((outcome, index) => (
                  <div key={index} className="flex items-center p-4 bg-green-50 rounded-lg border border-green-100">
                    <div className="w-10 h-10 bg-green-500 text-white rounded-full flex items-center justify-center mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-gray-800 font-medium">{language === 'marathi' ? outcome.marathi : outcome.english}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WebsiteSchemes